import { useState, useCallback } from 'react';
import { getProfiles, createNewProfile } from 'Api/apiService';
import { SbNotification } from 'uiCore';
import { ERROR_MESSAGES, ERROR_TITLES, WARNING_TITLES, getApiErrorMessage } from 'constants/profileManagement.constants';

const useProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProfiles = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getProfiles();
      if (response?.error || response?.error_code) {
        SbNotification.warning(WARNING_TITLES.FETCH_PROFILES, ERROR_MESSAGES.FETCH_PROFILES_FAILED, { key: 'profile-fetch-warning' });
        return;
      }
      setProfiles(Array.isArray(response) ? response : []);
    } catch (error) {
      SbNotification.warning(WARNING_TITLES.FETCH_PROFILES, ERROR_MESSAGES.FETCH_PROFILES_FAILED, { key: 'profile-fetch-warning' });
    } finally {
      setLoading(false);
    }
  }, []);

  const createProfile = useCallback(
    async (profileName) => {
      try {
        await createNewProfile(profileName);
        SbNotification.success('Success', 'Profile created successfully');
        await fetchProfiles();
        return true;
      } catch (error) {
        const msg = getApiErrorMessage(error, ERROR_MESSAGES.CREATE_PROFILE_FAILED);
        SbNotification.error(ERROR_TITLES.CREATE_PROFILE, msg);
        return false;
      }
    },
    [fetchProfiles],
  );

  return {
    profiles,
    loading,
    fetchProfiles,
    createProfile,
  };
};

export default useProfiles;
